import { boxShadow } from "../borders";
import { black, transparent, white } from "../colors";
import { fontSize } from "../typography";

export const MuiTooltip = {
  styleOverrides: {
    tooltip: {
      backgroundColor: white[100],
      color: black[100],
      boxShadow: boxShadow.primary,
      fontSize: fontSize.small,
      maxWidth: 300,
      padding: "12px",
    },
    arrow: {
      "&::before": {
        backgroundColor: white[100],
        border: `1px solid ${transparent[10]}`,
      },
    },
  },
};
